import React from 'react';
import { Container } from 'react-bootstrap';

const Privacy: React.FC = () => {
  return (
    <Container className="py-5">
      <h1 className="fw-bold mb-4">Privacy Policy</h1>
      <p className="text-muted">Last updated: {new Date().toLocaleDateString()}</p>
      
      <p>515 Soccer Academy ("we", "us", or "our") respects your privacy and is committed to protecting the personal information you share with us.</p>
      
      <h3>1. Information We Collect</h3>
      <p>We collect information you provide directly to us, such as when you register for a program, fill out a contact form, or sign up for a newsletter. This may include your name, email address, phone number, and player information.</p>
      
      <h3>2. How We Use Your Information</h3>
      <p>We use the information we collect to communicate with you, manage registrations, process payments (via third-party providers), and improve our programs.</p>
      
      <h3>3. Information Sharing</h3>
      <p>We do not sell your personal information. We may share information with third-party service providers who assist us in operating our website and conducting our business (e.g., payment processors, league registration systems).</p>
      
      <h3>4. Cookies and Analytics</h3>
      <p>We use Google Analytics to understand how visitors use our website. Google Analytics uses cookies to collect anonymous usage data.</p>
      
      <h3>5. Contact Us</h3>
      <p>If you have any questions about this Privacy Policy, please contact us at <a href="mailto:info@515soccer.org">info@515soccer.org</a>.</p>
    </Container>
  );
};

export default Privacy;
